<app-subscription-cart-list [disableActions]="true" [showExpandable]="false"></app-subscription-cart-list>
<p>Deine Abonnements kannst Du <a routerLink="/cart">hier </a>bearbeiten.</p>
